//------------ REACT IMPORT --------------//
import React from "react";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Card, Image } from "react-bootstrap";
//------------ IMAGES IMPORT ---------------//
import { CalendarBlack, Eye, Eye_2, PdfImg } from "../../../../assets/images";
import PaginationComponent from "../../CommanComponents/Pagination";
import { faPaperclip, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LabUpdate = () => {
    return (
        <>
            <div className="update_lab_tab">
                <div className="top_content_area">
                    <div className="left_area">
                        <p>Total Reports : 150</p>
                    </div>
                    <div className="right_area">
                        <div className="img_text_area">
                            <p>Today</p>
                            <div className="img_area">
                                <Image src={CalendarBlack} alt="..." />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container_area">
                    <div className="inner_container_area">
                        <div className="top_area">
                            <div className="left_top_area">
                                <div className="name">
                                    Hematology<FontAwesomeIcon icon={faPaperclip} className="icon_attach" />
                                </div>
                                <div className="txt">
                                    Test Name : CBC
                                </div>
                            </div>
                            <div className="right_top_area">
                                <div className="img_eye">
                                    <Image src={Eye} alt="..." />
                                </div>
                            </div>
                        </div>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Updated by: Jospeh Jones</p>
                            </div>
                            <div className="right_area">
                                <p>5 july, 2023 11:00AM</p>
                            </div>
                        </div>
                    </div>
                    <div className="inner_container_area">
                        <div className="top_area">
                            <div className="left_top_area">
                                <div className="name">
                                    Hematology<FontAwesomeIcon icon={faPaperclip} className="icon_attach" />
                                </div>
                                <div className="txt">
                                    Test Name : CBC
                                </div>
                            </div>
                            <div className="right_top_area">
                                <div className="img_eye">
                                    <Image src={Eye} alt="..." />
                                </div>
                            </div>
                        </div>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Updated by: Jospeh Jones</p>
                            </div>
                            <div className="right_area">
                                <p>5 july, 2023 11:00AM</p>
                            </div>
                        </div>
                    </div>
                    <div className="inner_container_area no_mb">
                        <div className="top_area">
                            <div className="left_top_area">
                                <div className="name">
                                    Hematology<FontAwesomeIcon icon={faPaperclip} className="icon_attach" />
                                </div>
                                <div className="txt">
                                    Test Name : CBC
                                </div>
                            </div>
                            <div className="right_top_area">
                                <div className="img_eye">
                                    <Image src={Eye} alt="..." />
                                </div>
                            </div>
                        </div>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Updated by: Jospeh Jones</p>
                            </div>
                            <div className="right_area">
                                <p>5 july, 2023 11:00AM</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="assign_task">
                    <a >
                        <div className="circle_area">
                            <div className="add_icon_area" >
                                <FontAwesomeIcon icon={faPlus} />
                                <p style={{ cursor: 'pointer' }}>Add Report</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <PaginationComponent />
        </>
    )
}

export default LabUpdate;